import { render, staticRenderFns } from "./GlobalSnackbar.vue?vue&type=template&id=0d859a80"
import script from "./GlobalSnackbar.vue?vue&type=script&lang=ts"
export * from "./GlobalSnackbar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports